<!--
 * @Date: 2020-07
 * @LastEditTime: 2020-07-22 15:50
 * @Description:编辑子账号 
-->  
<template>
  <div class="dialogBox">
    <el-dialog
      title="Edit"
      :visible.sync="showDialog"
      @close="clkCloseBtn"
      :close-on-click-modal="false"
      custom-class="borRad10"
      width="540px"
    >
      <el-form
        :model="accountInfo"
        :rules="rules"
        ref="accountInfo"
        class="resetCss font12"
      >
        <el-form-item label="Name：" prop="Name" label-width="150px">
          <el-input class="add-rInput" v-model="accountInfo.Name"></el-input>
        </el-form-item>
        <el-form-item label="Email：" prop="Email" label-width="150px">
          <el-input class="add-rInput" v-model="accountInfo.Email"></el-input>
        </el-form-item>
        <el-form-item label="Position：" prop="Position" label-width="150px">
          <el-input
            class="add-rInput"
            v-model="accountInfo.Position"
          ></el-input>
        </el-form-item>
        <template
          v-if="
            accountInfo.Position.length < 100 && accountInfo.Position.length > 0
          "
        >
          <div v-if="accountInfo.RightValue === 1" class="RightTip">
            Share my data, order, bill, etc
          </div>
          <div v-if="accountInfo.RightValue === 2" class="RightTip">
            Can view the order data of himself/herself and subordinate users
          </div>
        </template>
        <el-form-item>
          <div style="text-align: center" class="marTop10">
            <a class="lineBlue30 marR20" @click="clkCloseBtn">CANCAL</a>
            <a class="blueBtn30" @click="submitForm('accountInfo')">SUMBIT</a>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { post, fetch } from "@/ask/axios";
import { elAlert } from "@/utils/bulletBox";
export default {
  data() {
    return {
      curEidtELe: {}, //当前需要编辑的元素
      showDialog: false,
      accountInfo: {
        Name: "",
        Email: "",
        Position: "",
        RightValue: "",
        NameHolder: "Please enter you name",
        EmailHolder: "Please enter you Email",
        PositionHolder: "Please enter you Position",
      },
      rules: {
        Name: [
          { required: true, message: "Please enter you name", trigger: "blur" },
          { min: 1, max: 100, message: "Maximum is 100 characters" },
        ],
        Email: [
          {
            required: true,
            message: "Please enter you Email",
            trigger: "blur",
          },
          { min: 1, max: 50, message: "Maximum is 50 characters" },
          {
            //pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,  //正则
             pattern:
              /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i, //正则
            message: "Please enter a valid email address",
          },
        ],
        Position: [
          {
            required: true,
            message: "Please enter you Position",
            trigger: "blur",
          },
          { min: 1, max: 100, message: "Maximum is 100 characters" },
        ],
      },
    };
  },
  mounted() {},

  methods: {
    //显示弹窗
    clkDialog(item) {
      this.curEidtELe = item;
      this.accountInfo = this.$options.data().accountInfo; //初始accountInfo的值
      this.accountInfo.Name = item.UserName;
      this.accountInfo.RightValue = item.RightValue;
      this.accountInfo.Email = item.Mail;
      this.accountInfo.Position = item.Position;
      this.showDialog = true;
    },
    //关闭弹窗
    clkCloseBtn() {
      this.showDialog = false;
    },
    //调用新增接口
    editChildAccount() {
      let url = this.$api02 + "/api/EbayCustomer/WorkGroup/EditChildAccount";
      let parma = {
        Name: this.accountInfo.Name,
        Email: this.accountInfo.Email,
        Position: this.accountInfo.Position,
        RightValue: this.curEidtELe.RightValue,
        Level: this.curEidtELe.Level,
        CustomerId: this.curEidtELe.CustomerID,
        Status: this.curEidtELe.Status,
      };
      post(url, parma).then((res) => {
        if (res.IsOK) {
          elAlert(this, "success")
            .then(() => {
              this.clkCloseBtn();
              location.reload();
            })
            .catch(() => {
              this.clkCloseBtn();
              location.reload();
            });
        } else {
          // 调用bulletBox.js的方法
          let isEmailRe = false;
          if (res.Status) {
            res.Status.Errors.forEach((element) => {
              if (element.ErrorCode === "C0015") {
                isEmailRe = true;
              }
            });
            if (isEmailRe) {
              elAlert(this, "The Mailbox has been registered by another user");
            } else {
              elAlert(this, res.Message);
            }
          } else {
            elAlert(this, res.Message);
          }
        }
      });
    },
    // 校验
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editChildAccount();
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style>
.addChild .el-form-item__label {
  font-size: 12px !important;
  padding: 0;
  color: #000;
  font-weight: bold;
}
.addChild .el-form-item {
  margin-bottom: 8px;
}
.addChild .el-form-item .el-input__inner {
  font-size: 12px;
}
.addChild .el-form-item .el-form-item__error {
  color: red !important;
}
.addChild .el-form-item.is-error .el-input__inner {
  border-color: red !important;
}
.addChild
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  color: red !important;
}
</style>
<style scoped>
.lineBlue30 {
  display: inline-block;
  width: 100px;
  font-size: 12px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border: 1px solid #004fb1;
  border-radius: 30px;
  background-color: #fff;
  color: #004fb1 !important;
}
.blueBtn30 {
  display: inline-block;
  width: 100px;
  font-size: 12px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border: 1px solid #004fb1;
  border-radius: 30px;
  background-color: #004fb1;
  color: #fff !important;
}
.addChild {
  padding: 10px 12px 0 12px;
}
.add-rInput {
  width: 300px;
  font-size: 12px;
}
.add-leftName {
  display: inline-block;
  width: 140px;
  text-align: right;
  font-size: 12px;
  color: #000;
  font-weight: bold;
}
.RightTip {
  font-size: 12px;
  line-height: 1.5;
  width: 300px;
  margin-left: 150px;
  margin-top: -7px;
}
</style>


// WEBPACK FOOTER //
// src/components/userCenter/public/basicInfo/editAccount.vue